module.exports = __webpack_public_path__ + "6d0fbd01724fa7c5b56883d9b4886e96.svg";